/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ImageAttachment,
  ImageAttachmentRequestInput,
  SchemaValidationErrorResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create Image Attachment
 */
export const createImageAttachment = (
    imageAttachmentRequestInput: MaybeRefOrGetter<ImageAttachmentRequestInput>,
 signal?: AbortSignal
) => {
      imageAttachmentRequestInput = toValue(imageAttachmentRequestInput);

      return axiosClient<ImageAttachment>(
      {url: `/image_attachments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: imageAttachmentRequestInput, signal
    },
      );
    }




export const getCreateImageAttachmentMutationKey = () => ['createImageAttachment'] as const;

export const getCreateImageAttachmentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImageAttachment>>, TError,CreateImageAttachmentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createImageAttachment>>, TError,CreateImageAttachmentMutationVariables, TContext> => {

const mutationKey = getCreateImageAttachmentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createImageAttachment>>, CreateImageAttachmentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createImageAttachment(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateImageAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof createImageAttachment>>>
    export type CreateImageAttachmentMutationBody = ImageAttachmentRequestInput
    export type CreateImageAttachmentMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateImageAttachmentMutationVariables = {data: ImageAttachmentRequestInput}

    /**
 * @summary Create Image Attachment
 */
export const useCreateImageAttachment = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImageAttachment>>, TError,CreateImageAttachmentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createImageAttachment>>,
        TError,
        CreateImageAttachmentMutationVariables,
        TContext
      > => {
      return useMutation(getCreateImageAttachmentMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Image Attachment
 */
export const deleteImageAttachment = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/image_attachments/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteImageAttachmentMutationKey = () => ['deleteImageAttachment'] as const;

export const getDeleteImageAttachmentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImageAttachment>>, TError,DeleteImageAttachmentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteImageAttachment>>, TError,DeleteImageAttachmentMutationVariables, TContext> => {

const mutationKey = getDeleteImageAttachmentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteImageAttachment>>, DeleteImageAttachmentMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteImageAttachment(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteImageAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteImageAttachment>>>

    export type DeleteImageAttachmentMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteImageAttachmentMutationVariables = {id: string}

    /**
 * @summary Delete Image Attachment
 */
export const useDeleteImageAttachment = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImageAttachment>>, TError,DeleteImageAttachmentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteImageAttachment>>,
        TError,
        DeleteImageAttachmentMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteImageAttachmentMutationOptions(options), queryClient);
    }
    /**
 * @summary Show Image Attachment
 */
export const showImageAttachment = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ImageAttachment>(
      {url: `/image_attachments/${id}`, method: 'GET', signal
    },
      );
    }




export const getShowImageAttachmentQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'image_attachments',id
    ] as const;
    }


export const getShowImageAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof showImageAttachment>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showImageAttachment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShowImageAttachmentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showImageAttachment>>> = ({ signal }) => showImageAttachment(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof showImageAttachment>>, TError, TData>
}

export type ShowImageAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof showImageAttachment>>>
export type ShowImageAttachmentQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Show Image Attachment
 */

export function useShowImageAttachment<TData = Awaited<ReturnType<typeof showImageAttachment>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showImageAttachment>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShowImageAttachmentQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






